import React, { useState } from "react";
import I18n from "i18n-js";

import ActionButton from "../../../commons/ActionButton";

import UserAdd from "../../../Users/components/UserAdd";

import addIcon from "../../../assets/icons/add.svg";

const AddMembersButton = ({ loggedUser, team }) => {
  const canAddNewMembers = team.team_members_count < team.max_members;

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    if (canAddNewMembers) {
      setShowModal(true);
      return;
    }

    window.location.assign(`/plans?plan=larger-teams&locale=${I18n.locale}`)
  };

  const closeModal = (event) => {
    event.preventDefault();
    setShowModal(false);
  };

  return (
    <>
      <ActionButton
        title={I18n.t("dashboard.actions.add_members")}
        icon={addIcon}
        onClick={openModal}
      />
      <UserAdd
        isModalOpen={showModal}
        hideModal={closeModal}
        currentTeam={team}
        loggedUser={loggedUser}
      />
    </>
  );
}

export default AddMembersButton;
